import { useEffect, useState } from 'react';
import { startsWithHttps } from '../../utils/helpers/asset/startsWithHttps';

export const useSignedUrl = (key: string, deps = [], condition = true) => {
  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    if (condition && key && key !== url) {
      getAssetUrl();
    }
  }, [...deps]);

  const getAssetUrl = async () => {
    if (key) {
      try {
        let staticUrl = process.env.NEXT_PUBLIC_ASSET_CDN;
        if (startsWithHttps(key)) {
          staticUrl = '';
          setUrl(key);
          return key;
        }
        const url = `${staticUrl}${key}`;
        setUrl(url);
        return url;
      } catch (error) {
        setUrl(key);
      }
    }
  };

  return {
    url: url,
    getAssetUrl,
  };
};

export const useSignedDefaultUrl = (
  key: string,
  deps = [],
  condition = true
) => {
  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    if (condition && key && key !== url) {
      getAssetUrl();
    }
  }, [...deps]);

  const getAssetUrl = async () => {
    if (key) {
      try {
        let staticUrl = process.env.NEXT_PUBLIC_ASSET_DEFAULT_CDN;
        if (startsWithHttps(key)) {
          staticUrl = '';
        }
        const url = `${staticUrl}${key}`;
        setUrl(url);
        return url;
      } catch (error) {
        setUrl(key);
      }
    }
  };

  return {
    url: url,
    getAssetUrl,
  };
};

export const getThumbnailURL = (
  key: string,
  type: string,
  isMobile: boolean
) => {
  let thumbnail;
  try {
    let staticUrl = process.env.NEXT_PUBLIC_ASSET_CDN;
    if (startsWithHttps(thumbnail)) {
      staticUrl = '';
    }
    const url = `${staticUrl}${thumbnail}`;
    return url;
  } catch (error) {
    return thumbnail;
  }
};
